import { useEffect, useState } from "react";
import { useLenis } from "../providers/LenisProvider";

/**
 * Zwraca true, gdy strona jest przewinięta poniżej progu (domyślnie 40px).
 * Podłącz do istniejącego <header> tak:
 *
 *   const shrink = useHeaderShrink();
 *   <header className={shrink ? "py-3 border-b border-white/5" : "py-5"}>
 *
 * Padding wartości (py-5 → py-3) to przykład — dopasuj do obecnych klas headera.
 */
export function useHeaderShrink(thresholdPx = 40): boolean {
  const lenis = useLenis();
  const [shrink, setShrink] = useState(false);

  useEffect(() => {
    function checkNative() {
      setShrink(window.scrollY > thresholdPx);
    }

    if (lenis) {
      const onScroll = () => setShrink(lenis.scroll > thresholdPx);
      lenis.on("scroll", onScroll);
      return () => lenis.off("scroll", onScroll);
    }

    checkNative();
    window.addEventListener("scroll", checkNative, { passive: true });
    return () => window.removeEventListener("scroll", checkNative);
  }, [lenis, thresholdPx]);

  return shrink;
}
